import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diy-landing-layout',
  templateUrl: './diy-landing-layout.component.html',
  styleUrls: ['./diy-landing-layout.component.css']
})
export class DiyLandingLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
